import { render, staticRenderFns } from "./gc-header-right.vue?vue&type=template&id=b0a3effe"
import script from "./gc-header-right.vue?vue&type=script&lang=js"
export * from "./gc-header-right.vue?vue&type=script&lang=js"
import style0 from "./gc-header-right.vue?vue&type=style&index=0&id=b0a3effe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports